module.exports = __webpack_public_path__ + "img/mic_close.25ba8566.svg";